// This precaches library
export const initialiseCompressionLibrary = () =>
  import('browser-image-compression').then((imageCompression) => imageCompression);

// This calls library, will automatically use cached library if found
export const compressImage = (file, options) =>
  import('browser-image-compression').then((imageCompression) =>
    imageCompression.default(file, options),
  );
